
import { defineComponent, ref, useContext, useFetch } from '@nuxtjs/composition-api'
import get from 'lodash/get'
import uniq from 'lodash/uniq'
import { setupGtmCdpAction, setupGtmViewItemList } from '~/assets/composition/setup-gtm'

export default defineComponent({
  props: {
    production: { type: Object, required: false, default: undefined },
    relatedEventUris: { type: Array, required: false, default: () => [] },
  },
  setup(props) {
    const viewItemList = setupGtmViewItemList('NETA')
    const onViewport = ({ index, event }) => viewItemList([event], index)
    const suggestedEventUris = ref([...props.relatedEventUris])
    const gtmCdpAction = setupGtmCdpAction()

    if (suggestedEventUris.value.length < 3 && props.production) {
      const { app, $bridgeFetch } = useContext()
      useFetch(async () => {
        const result = await $bridgeFetch(`/api/neta/${app.i18n.locale}Default/${props.production.uid}`)
        suggestedEventUris.value = uniq([...props.relatedEventUris, ...result.result.map((item) => item.uri)].slice(0, 4))
      })
    }

    function onEventCardClick() {
      gtmCdpAction('CV07 - You might also like concert clicked')
    }

    return {
      get,
      onViewport,
      suggestedEventUris,
      onEventCardClick,
    }
  },
})
